import { useEffect, useState } from "react";
import type { Kpi, Period } from "./types";
import { getKpi } from "./api";

export function useKpi(managerId: string, period: Period, periodId: string) {
  const [kpi, setKpi] = useState<Kpi | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!managerId || !periodId) { setKpi(null); return; }
    let cancelled = false;
    setLoading(true);
    setError(null);
    getKpi(managerId, period, periodId)
      .then(r => { if (!cancelled) setKpi(r.kpi); })
      .catch(e => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [managerId, period, periodId]);

  return { kpi, loading, error };
}
